import React from 'react';
import { ModuleType } from '../../../../../types/modules';
import Zone, { ZoneGroup } from '../../../Layout/Zone';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import JournalSlider from './JournalSlider';
import StatusSlider from './StatusSlider';
import PollSlider from './PollSlider';
import { ZoneType } from '../../../../../types/layout';

import EmptyState from '../_partials/EmptyState';

import s from './PostsAll.scss';

const mapModuleTypeToWidgetComponent = {
  [ModuleType.JOURNALS]: JournalSlider,
  [ModuleType.STATUSES]: StatusSlider,
  [ModuleType.POLLS]: PollSlider,
};

export interface Props {
  hasNoPosts: boolean;
  isCurrentUserProfileOwner: boolean;
}

export class PostsAll extends React.Component<Props> {
  render() {
    const { hasNoPosts, isCurrentUserProfileOwner } = this.props;
    if (hasNoPosts && !isCurrentUserProfileOwner) {
      return <EmptyState postType="all" view="large" />;
    }

    return (
      <div className={s['root']}>
        <ZoneGroup>
          <Zone
            type={ZoneType.TOP_BAR}
            isRemovable={false}
            mapModuleTypeToWidgetComponent={mapModuleTypeToWidgetComponent}
          />
        </ZoneGroup>
      </div>
    );
  }
}

export default withSectionFetchSpinner(PostsAll) as React.ComponentType<Props>;
